"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var TokenWrapper = /** @class */ (function (_super) {
    __extends(TokenWrapper, _super);
    function TokenWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenWrapper.prototype.findOption = function () {
        return this.find('.awsui-select-option');
    };
    TokenWrapper.prototype.findLabel = function () {
        return this.find('.awsui-select-option-label');
    };
    TokenWrapper.prototype.findDismiss = function () {
        return this.find('.awsui-token-dismiss');
    };
    return TokenWrapper;
}(dom_1.ElementWrapper));
exports.default = TokenWrapper;
//# sourceMappingURL=awsui-token.js.map